import { useCheckUserPermissions } from '@hooks/checkUserPermisions';
import { useApi } from '@hooks/useApi';
import { ApiError, MetaData, Order } from '@root/globalTypes';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';

interface OrdersRespSuccess {
  orders: Order[];
  meta: MetaData | undefined;
}

interface OrdersReturn extends OrdersRespSuccess {
  loading: boolean;
}

export const useMerchantOrdersList = (merchantId: string): OrdersReturn => {
  const { isLogged } = useCheckUserPermissions();
  const { query } = useApi();
  const { data, isPending } = useQuery<OrdersRespSuccess, ApiError>({
    queryKey: [...queryKeys.orders],
    queryFn: () =>
      query({
        path: `v1/acquirer/merchants/${merchantId}/orders`,
      }),
    placeholderData: (previousValue) => previousValue,
    enabled: isLogged,
  });

  return {
    orders: data?.orders || [],
    meta: data?.meta || undefined,
    loading: isPending,
  };
};
